import React from "react";
import { string, oneOfType, number, objectOf, object, shape, array, oneOf, func } from "prop-types";
import cx from "classnames";
// eslint-disable-next-line import/no-cycle
import { Card } from "../../../sharedComponents/Card";
import { StarRating } from "../../StarRating";
import { RCL as useTranslation } from "../../RCL";
// eslint-disable-next-line import/no-cycle
import { CardLink } from "../HeroCard";
import * as styles from "./HotelCardTopResults.module.scss";

const HotelCardTopResults = ({
	image,
	header,
	link,
	style,
	subheader,
	stars,
	button,
	className,
	minAge,
}) => {
	const adultsOnlyLabel = useTranslation({ searchKey: "adults-only" });

	return (
		<Card className={cx(styles.hotelCard, className)} style={style}>
			{subheader && <Card.Subheader className={styles.subheading}>{subheader}</Card.Subheader>}
			<Card.Image
				className={styles.image}
				src={image.src}
				alt={image.alt}
				fluid={image.fluid}
				cloudinary={image.cloudinary}
			/>
			<Card.BodyContainer className={styles.contentContainer}>
				<Card.Header className={styles.heading}>
					{header?.length >= 50 ? `${header.substring(0, 50)}...` : header}
				</Card.Header>
				<div className={styles.ratingsContainer}>
					{!!Number(stars) && (
						<div>
							<StarRating rating={stars} />
						</div>
					)}
					{minAge >= 16 && <p className={styles.adultsOnly}>{`${adultsOnlyLabel} (${minAge}+)`}</p>}
				</div>
				<div className={styles.buttonsContainer}>
					{button?.to && (
						<Card.Button to={button.to} size="sm" icon={button.icon}>
							{button.text}
						</Card.Button>
					)}
					{link?.to && (
						<Card.Link to={link.to} className={cx(styles.link)} iconSize="swg-text-sm">
							<span className={cx(styles.linkText)}>{link.text}</span>
						</Card.Link>
					)}
				</div>
			</Card.BodyContainer>
			{link?.to && !button && (
				<CardLink link={link.to} text={header || link?.text} className={cx(styles.hotelCardLink)} />
			)}
		</Card>
	);
};

HotelCardTopResults.propTypes = {
	image: shape({
		fluid: oneOfType([object, array]),
		fixed: oneOfType([object, array]),
		source: shape({
			src: string,
			srcSet: string,
			sizes: string,
		}),
		alt: string,
		src: string,
	}).isRequired,
	header: string.isRequired,
	subheader: string,
	link: shape({
		to: string.isRequired,
		target: string,
		icon: shape({
			svg: shape({
				content: string,
			}),
		}),
		text: string,
	}).isRequired,
	button: shape({
		icon: string,
		iconPlacement: oneOf(["right", "left"]),
		onClick: func,
		text: string,
	}),
	style: objectOf(oneOfType([string, number])),

	stars: number.isRequired,
	className: string,
	minAge: number,
};

HotelCardTopResults.defaultProps = {
	style: {},
	subheader: null,
	button: null,
	className: null,
	minAge: null,
};

export default HotelCardTopResults;
export { HotelCardTopResults };
